module.exports = __webpack_public_path__ + "img/photo02.e43c7633.jpg";